export class MoreQuestions {
    store;

    async init(store) {
        this.store = store;
        await this._initTryFreeButton();
    }

    async _initTryFreeButton() {
        const tryFreeButton: HTMLButtonElement = document.querySelector('.more-questions__button');

        tryFreeButton.addEventListener('click', (event) => {
            this.store.dispatch('modalManagementSystem/addModalWindow', {
                content: 'FormConvertFlow',
            })
        })
    }
}